import appTypes from "./app.types"
export const toggleWarning=()=>({type: appTypes.VISIBILITY})